export default __webpack_public_path__ + "static/media/Waiting-Dark.6238703a.svg";